import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "22",
  height: "18",
  viewBox: "0 0 22 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M0.208344 9.00016C0.208344 8.35583 0.730678 7.8335 1.37501 7.8335H20.625C21.2693 7.8335 21.7917 8.35583 21.7917 9.00016C21.7917 9.6445 21.2693 10.1668 20.625 10.1668H1.37501C0.730678 10.1668 0.208344 9.6445 0.208344 9.00016Z",
      fill: "#0A072D"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M0.208344 2.00016C0.208344 1.35583 0.730678 0.833496 1.37501 0.833496H20.625C21.2693 0.833496 21.7917 1.35583 21.7917 2.00016C21.7917 2.6445 21.2693 3.16683 20.625 3.16683H1.37501C0.730678 3.16683 0.208344 2.6445 0.208344 2.00016Z",
      fill: "#0A072D"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M0.208344 16.0002C0.208344 15.3558 0.730678 14.8335 1.37501 14.8335H20.625C21.2693 14.8335 21.7917 15.3558 21.7917 16.0002C21.7917 16.6445 21.2693 17.1668 20.625 17.1668H1.37501C0.730678 17.1668 0.208344 16.6445 0.208344 16.0002Z",
      fill: "#0A072D"
    }, null, -1)
  ])))
}
export default { render: render }